import React, { useState } from "react";
import { FloatingLabel } from "react-input-textboxs";

const renderCells = (userNewData, userNewTypes, searchText, props) => {
  const newList = userNewData.map((_ele, i) => {
    if (_ele.login_id.indexOf(searchText.toUpperCase()) > -1) {
      // let ut = userType.find((k) => _ele.user_type === k.value);
      return (
        <li key={i} className="table-row data">
          <div className="cell loginid">
            <span>{_ele.login_id}</span>
          </div>
          <div className="cell loginid">
            <span>{_ele.EmployeeName}</span>
          </div>{" "}
          <div className="cell usertype">
            <span>{_ele.Usertypedesc}</span>
          </div>
          {"   "}
          <div className="cell usertype" style={{paddingLeft: "15px"}}>
            <span>{_ele.Productdesc}</span>
          </div>
          {"   "}
          <div className="cell usertype" style={{paddingLeft: "15px"}}>
            <span>{_ele.Team ? _ele.Team : ""}</span>
          </div>
          <div className="cell lang">
            <span>{_ele.language}</span>
          </div>
          <div className="cell lang">
            <span>{_ele.OtherLanguages}</span>
          </div>
          <div className="cell lang">
            <span>{_ele.status === 1 ? "Active" : "In Active"}</span>
          </div>
          <div className="cell action">
            <button
              onClick={() => [
                props.handleChange(_ele, "toBeUpdated"),
                props.handleModel(true),
              ]}
              className="btn submit"
            >
              Edit
            </button>
          </div>
        </li>
      );
    } else {
      return null;
    }
  });
  return newList;
  // return list;
};
export default function UserList(props) {
  const [searchText, setSearchText] = useState("");
  const { userNewData, userNewTypes } = props;
  return (
    <div className="userlist-model">
      <ul className="table">
        <li className="search-bar">
          <div className="search">
            <FloatingLabel
              label={"Search by User ID"}
              type={"text"}
              value={searchText}
              variant="standared"
              onChange={(value) => setSearchText(value)}
            />
            <button className="btn">Search</button>
          </div>
        </li>
        <li className="table-row heading">
          <div className="cell loginid">
            <span>User Id</span>
          </div>
          <div className="cell loginid">
            <span>Employee Name</span>
          </div>
          <div className="cell usertype">
            <span>User type</span>
          </div>{" "}
          <div className="cell usertype" style={{paddingLeft: "15px"}}>
            <span>Products</span>
          </div>{" "}
          <div className="cell usertype" style={{paddingLeft: "15px"}}>
            <span>Team</span>
          </div>
          <div className="cell lang">
            <span>Base Language</span>
          </div>
          <div className="cell lang">
            <span>Other Languages</span>
          </div>
          <div className="cell lang">
            <span>Status</span>
          </div>
          <div className="cell action">
            <span>Action</span>
          </div>
        </li>
        {renderCells(userNewData, userNewTypes, searchText, props)}
      </ul>
    </div>
  );
}
